var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceCoinsMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.72,100.59v11.53m0-63.29v12m11.43,4.52s-21-8.81-23,4.07C92.58,85.77,117.7,76,118.6,90.2s-18.93,10.85-24.12,5.42M174,122.09a29.92,29.92,0,0,1,3.18,13.3c0,24.72-31.69,44.75-70.78,44.75s-70.79-20-70.79-44.75a30,30,0,0,1,3.19-13.31M174,95a29.9,29.9,0,0,1,3.18,13.31c0,24.7-31.69,44.74-70.78,44.74s-70.79-20-70.79-44.74A30,30,0,0,1,38.83,95M177.21,81.16c0,24.71-31.69,44.74-70.78,44.74s-70.79-20-70.79-44.74,31.7-44.75,70.79-44.75S177.21,56.44,177.21,81.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceCoinsMoney);
export default __webpack_public_path__ + "static/media/FINANCE_COINS_MONEY.ed54db5fc0449d205a313e5fe5aac9a8.svg";
export { ForwardRef as ReactComponent };